import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";
import moment from "moment";

const initialState = {
  compitatorDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 100,
    page: 1,
  },
  compitatorSearchFilters: {
    searchText: "",
  },
  availabilityOtaDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  availabilityOtaSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(89, "days").format("YYYY-MM-DD"),
    room_type_id: 0,
  },
  otaAvailResult: {},
  otaAvailResultAvail: {},
  otaAvailotaAvail: {},
  invDiffOtaDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  invDiffOtaSearchFilters: {
    searchText: "",
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(89, "days").format("YYYY-MM-DD"),
    room_type_id: 0,
  },
  otainvDiffAvailResultAvail: {},
  otainvDiffAvailotaAvail: {},
  otaLogsDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  otaLogsSearchFilters: {
    searchText: "",
    startDate: moment().subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    log_type: 3,
    room_type: 0,
  },
  roomRateDatagridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  roomRateSearchFilters: {
    searchText: "",
    rateActivityStatus: "",
  },
  discountedRateDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  seasonalDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  seasonalSearchFilters: {
    searchText: "",
  },
  cancellationDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  cancellationSearchFilters: {
    searchText: "",
  },
};
const roomRateTabSlice = createSlice({
  name: "roomRateTab",
  initialState: initialState,
  reducers: {
    compitatorDatagridOptionsSuccess: (state, action) => {
      state.compitatorDatagridOptions = {
        ...state.compitatorDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    compitatorSearchFiltersSuccess: (state, action) => {
      state.compitatorSearchFilters = {
        ...state.compitatorSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    availabilityOtaDatagridOptionsSuccess: (state, action) => {
      state.availabilityOtaDatagridOptions = {
        ...state.availabilityOtaDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    availabilityOtaSearchFiltersSuccess: (state, action) => {
      state.availabilityOtaSearchFilters = {
        ...state.availabilityOtaSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    otaAvailResultSuccess: (state, action) => {
      state.otaAvailResult = action.payload;
    },
    otaAvailResultAvailSuccess: (state, action) => {
      state.otaAvailResultAvail = action.payload;
    },
    otaAvailotaAvailSuccess: (state, action) => {
      state.otaAvailotaAvail = action.payload;
    },
    invDiffOtaDatagridOptionsSuccess: (state, action) => {
      state.invDiffOtaDatagridOptions = {
        ...state.invDiffOtaDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    invDiffOtaSearchFiltersSuccess: (state, action) => {
      state.invDiffOtaSearchFilters = {
        ...state.invDiffOtaSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    otainvDiffAvailResultAvailSuccess: (state, action) => {
      state.otainvDiffAvailResultAvail = action.payload;
    },
    otainvDiffAvailotaAvailSuccess: (state, action) => {
      state.otainvDiffAvailotaAvail = action.payload;
    },
    otaLogsDatagridOptionsSuccess: (state, action) => {
      state.otaLogsDatagridOptions = {
        ...state.otaLogsDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    otaLogsSearchFiltersSuccess: (state, action) => {
      state.otaLogsSearchFilters = {
        ...state.otaLogsSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    roomRateDatagridOptionsSuccess: (state, action) => {
      state.roomRateDatagridOptions = {
        ...state.roomRateDatagridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    roomRateSearchFiltersSuccess: (state, action) => {
      state.roomRateSearchFilters = {
        ...state.roomRateSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    discountedRateDataGridOptionsSuccess: (state, action) => {
      state.discountedRateDataGridOptions = {
        ...state.discountedRateDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    seasonalDataGridOptionsSuccess: (state, action) => {
      state.seasonalDataGridOptions = {
        ...state.seasonalDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    seasonalSearchFiltersSuccess: (state, action) => {
      state.seasonalSearchFilters = {
        ...state.seasonalSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    cancellationDataGridOptionsSuccess: (state, action) => {
      state.cancellationDataGridOptions = {
        ...state.cancellationDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    cancellationSearchFiltersSuccess: (state, action) => {
      state.cancellationSearchFilters = {
        ...state.cancellationSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
  },
});

export const {
  compitatorDatagridOptionsSuccess,
  compitatorSearchFiltersSuccess,
  availabilityOtaDatagridOptionsSuccess,
  availabilityOtaSearchFiltersSuccess,
  otaAvailResultSuccess,
  otaAvailResultAvailSuccess,
  otaAvailotaAvailSuccess,
  invDiffOtaDatagridOptionsSuccess,
  invDiffOtaSearchFiltersSuccess,
  otainvDiffAvailResultAvailSuccess,
  otainvDiffAvailotaAvailSuccess,
  otaLogsDatagridOptionsSuccess,
  otaLogsSearchFiltersSuccess,
  roomRateDatagridOptionsSuccess,
  roomRateSearchFiltersSuccess,
  discountedRateDataGridOptionsSuccess,
  seasonalDataGridOptionsSuccess,
  seasonalSearchFiltersSuccess,
  cancellationDataGridOptionsSuccess,
  cancellationSearchFiltersSuccess,
} = roomRateTabSlice.actions;
export default roomRateTabSlice.reducer;
